'use client';
import { makeImageMeta } from 'components/ui-kit/image';
import { TImageMetaParams } from 'components/ui-kit/image/image.utils';
import { HttpClient, ProductTransport, TProductResponse } from 'lib';
import { productService } from 'lib/services';
import { MediaBreakpoint } from '../../../_shared';

type TVideoMeta = {
  href: string;
  thumbnail: TImageMetaParams;
};

/**
 * Сервис страницы о нас
 *
 * Под собой использует ProductService
 */
export class AboutPageService {
  private transport: ProductTransport;

  constructor(httpClient: HttpClient) {
    this.transport = new ProductTransport(httpClient);
  }

  getWelcomeImageMedia(): TImageMetaParams {
    const image = makeImageMeta({
      src: '/images/pages/about/about_welcome.jpeg',
      alt: 'О нас',
      formats: [
        { type: 'webp', media: MediaBreakpoint.SMALL_SCREEN },
        { type: 'jpeg', media: MediaBreakpoint.SMALL_SCREEN },
      ],
    });

    return image;
  }

  getVideoMedia(): TVideoMeta {
    const video = {
      href: 'https://youtu.be/j5kCJ_RMpow',
      thumbnail: makeImageMeta({
        src: '/images/pages/about/about_video_preview.jpeg',
        alt: 'Решительные и смелые здесь и в любой точке',
        formats: [
          { type: 'webp', media: MediaBreakpoint.SMALL_SCREEN },
          { type: 'jpeg', media: MediaBreakpoint.SMALL_SCREEN },
        ],
      }),
    };

    return video;
  }
}

export const aboutPageService = new AboutPageService(new HttpClient());
